// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"x_-z","mobileContainer":"y_-z","tooltipTitle":"z_-z","ecoIcon":"A_-z"};